"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  errorIcon: {
    id: 'components.Snackbar.errorIcon',
    defaultMessage: 'Ícone de erro'
  },
  successIcon: {
    id: 'components.Snackbar.successIcon',
    defaultMessage: 'Ícone de sucesso'
  },
  infoIcon: {
    id: 'components.Snackbar.infoIcon',
    defaultMessage: 'Ícone de informação'
  }
});